import React from 'react';
import PropTypes from 'prop-types';
import globals from "../globals";
import Heading from "../elements/Heading";

class TwoColumnTextBlocks extends React.Component {

	componentDidMount() {
		this.controller = globals.genericAnimation(this.content);
	}

	componentWillUnmount() {
		globals.destroy(this.controller);
	}

	render() {
		return (
			<section className="two-column-text-blocks">
				<div className="inner">
					<div className="row" ref={el => this.content = el}>
						<div className="col-md-10 col-md-offset-1 col-xs-12 centered">
							<Heading title={this.props.title} />
							{this.props.children}
						</div>
						<div className="col-md-8 col-md-offset-2 col-xs-12 blocks-container">
							<div className="row">
								{this.props.textBlocks.map((item, key) => {
									return (
										<div key={key} className="col-md-5 col-md-offset-1 col-xs-12">
											<h3>{item.title}</h3>
											<p dangerouslySetInnerHTML={{__html: item.content}} />
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>
				<div className="bottom-wave-darkgreen" />
			</section>
		);
	}

}

TwoColumnTextBlocks.propTypes = {
	title: PropTypes.string.isRequired,
	textBlocks: PropTypes.array.isRequired
};

export default TwoColumnTextBlocks;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/TwoColumnTextBlocks.js